<template>
  <div class="narrative-card-note">
    <button class="close-note-x-button" @click="$emit('close')">&times;</button>

    <div class="note-content-area">
      <div class="note-main-content">
        <div class="note-header">
          <div class="note-title-group">
            <div class="note-icon" />
            <span class="note-creator-label">{{ list.creator }}'s Note</span>
          </div>
        </div>
        <div class="note-body">
          <h5 class="note-wine-title">{{ product.title }}</h5>
          <p>{{ userListProduct.note }}</p>
        </div>
      </div>
    </div>
    <button class="close-note-button" @click="$emit('close')">
      Close Note
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  list: {
    type: Object,
    required: true,
  },
})

const userListProduct = computed(() => {
  if (props.list.products) {
    return props.list.products.find(
      (x) => x.product.id == props.product.product_id,
    )
  }
  return null
})

defineEmits(['close'])
</script>
